import { instance, errorService } from '@/services/api'
import { projectAPIs } from '@/services/authConstantsV1'
import _ from 'lodash'
import {
  showNotification,
  evaluateQantity,
  convertCalculation,
} from '@/services/calculate'
import { formatCurrency } from '@/services/convert'
import {
  addGridRecord,
  updateGridRecord,
  updateRowStyle,
  updateMultipleGridRecord,
  addMultipleGridRecord,
} from '@/services/grid'
import { apiRequestArray, validateNumber } from '@/services/config'
import { AgGridVue } from 'ag-grid-vue'
import CurrencyRenderer from '@/components/DynamicComponents/Renderers/currencyRenderer'
import CustomFilter from '@/components/DynamicComponents/Renderers/customFilter'
import ToolTipRenderer from '@/components/DynamicComponents/Renderers/tooltipRenderer'
import TextEditor from '@/components/DynamicComponents/Renderers/textEditor'
import InputNumberEditor from '@/components/DynamicComponents/Renderers/inputNumberEditor'
import SelectEditor from '@/components/DynamicComponents/Renderers/selectEditorDynamic'
import ActionRenderer from '@/components/DynamicComponents/Renderers/actionRendere'
import AutoCompleteRenders from '@/components/DynamicComponents/Renderers/autoCompleteRenders'
import CalculationEditor from '@/components/DynamicComponents/Renderers/calculationEditor'
import ContractComponent from '@/components/DynamicComponents/Admin/MasterData/Project/Contract'
import CategoryCodeComponent from '@/components/DynamicComponents/Admin/MasterData/Project/CategoryCode'
import TakeoffComponent from '@/components/DynamicComponents/Admin/MasterData/Project/Takeoff'
import TreeTakeoffs from '@/components/DynamicComponents/Projects/TreeTakeoffs'

export default {
  components: {
    'ag-grid-vue': AgGridVue,
    'add-category-code': CategoryCodeComponent,
    'add-contract': ContractComponent,
    'add-takeoff': TakeoffComponent,
    'tree-takeoff': TreeTakeoffs,
  },
  props: [
    'takeoffs',
    'columns',
    'screenIndentifier',
    'dropdownData',
    'groupDetails',
  ],
  data() {
    return {
      data: [],
      redrawTable: false,
      loading: false,
      gridOptions: {
        suppressCellSelection: true,
        alwaysShowVerticalScroll: true,
        debounceVerticalScrollbar: true,
        alwaysShowHorizontalScroll: true,
        headerHeight: 30,
        rowHeight: 28,
        suppressRowClickSelection: true,
        rowSelection: 'multiple',
        tooltipShowDelay: 0,
        rowDragManaged: true,
        suppressContextMenu: true,
        stopEditingWhenGridLosesFocus: false,
        defaultColDef: {
          suppressMovable: true,
          singleClickEdit: true,
          sortable: true,
          menuTabs: ['filterMenuTab'],
          editable: true,
        },
      },
      columnDefs: null,
      frameworkComponents: null,
      width: '100%',
      height: '47rem',
      selectedRowKeys: [],
      selectedRows: [],
      formatCurrency: formatCurrency,
      isAddContract: false,
      isAddCategory: false,
      isAddTakeoff: false,
      takeoffDetails: null,
      changeIndex: undefined,
      isCalculationError: false,
      isBlurCalled: true,
      postSort: null,
      keys: [
        'contract',
        'categoryCode',
        'additionalDescription',
        'takeoff',
        'calculation',
        'quantity',
        'unit',
        'unitCost',
        'multiplier',
        'constructionQualityFactor',
      ],
      visibleTakeoff: false,
      isValidTakeoff: false,
      checked: false,
    }
  },
  beforeMount() {
    this.loadingConfig()
    this.postSort = rowNodes => {
      const takeoffs = []
      for (let i = 0; i < rowNodes.length; i++) {
        takeoffs.push(rowNodes[i].data)
      }
      this.data = [...takeoffs]
    }
  },
  created() {
    this.$root.$off('onUpdateTakeoffs')
    this.$root.$off('onCloneTakeoffs')
    this.$root.$off('onDeleteTakeoffs')
    this.$root.$on('onUpdateTakeoffs', this.onUpdateTakeoff)
    this.$root.$on('onCloneTakeoffs', this.cloneTakeoff)
    this.$root.$on('onDeleteTakeoffs', this.deleteRecord)
  },
  mounted() {
    this.loadingConfig()
    this.$root.$off('reloadTakeoffs')
    this.$root.$off('stopLoading')
    this.$root.$on('reloadTakeoffs', this.reloadTakeoffs)
    this.$root.$on('stopLoading', this.stopLoading)
  },
  beforeDestroy() {
    this.$root.$off('onUpdateTakeoffs')
    this.$root.$off('onCloneTakeoffs')
    this.$root.$off('onDeleteTakeoffs')
    window.removeEventListener('resize', this.getWindowSize)
  },
  methods: {
    loadingConfig() {
      this.frameworkComponents = {
        actionCellRenderer: ActionRenderer,
        customFilter: CustomFilter,
        selectEditor: SelectEditor,
        costPriceCellRenderer: CurrencyRenderer,
        inputNumberEditor: InputNumberEditor,
        toolTipRenderer: ToolTipRenderer,
        textEditor: TextEditor,
        autocomplete: AutoCompleteRenders,
        calculationEditor: CalculationEditor,
      }

      this.columnDefs = [
        {
          checkboxSelection: true,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          floatingFilter: false,
          width: 5,
          suppressSizeToFit: true,
          resizable: false,
          editable: false,
          pinned: 'left',
        },
        {
          headerName: '',
          field: 'isValidTakeoff',
          hide: true,
        },
        {
          headerName: 'Contract',
          field: 'contract',
          cellStyle: { textAlign: 'left' },
          width: 80,
          cellEditor: 'selectEditor',
          cellRenderer: 'toolTipRenderer',
          headerTooltip: 'Contract',
          suppressSizeToFit: true,
          resizable: true,
          cellRendererParams: {
            type: 'estimateTakeoff',
            dropdownName: 'contract',
            dropdownData: this.dropdownData,
          },
          filter: 'customFilter',
        },
        {
          headerName: 'Cat Code',
          field: 'categoryCode',
          cellEditor: 'selectEditor',
          cellStyle: { textAlign: 'left' },
          cellRendererParams: {
            type: 'estimateTakeoff',
            dropdownName: 'category',
            dropdownData: this.dropdownData,
          },
          width: 100,
          cellRenderer: 'toolTipRenderer',
          headerTooltip: 'Cat Code',
          suppressSizeToFit: true,
          resizable: true,
          filter: 'customFilter',
        },
        {
          headerName: 'Additional Description',
          field: 'additionalDescription',
          headerClass: 'header-center',
          cellStyle: { textAlign: 'center', backColor: 'red' },
          cellEditor: 'textEditor',
          cellRendererParams: {
            type: 'estimateTakeoff',
            placeholder: 'Additional Description',
          },
          width: 150,
          headerTooltip: 'Additional Description',
          suppressSizeToFit: true,
          resizable: true,
          cellRenderer: 'toolTipRenderer',
          filter: 'customFilter',
        },
        {
          headerName: 'Takeoff Description',
          field: 'takeoff',
          cellEditor: 'autocomplete',
          cellStyle: { textAlign: 'left' },
          cellRendererParams: {
            type: 'estimateTakeoff',
            name: 'takeoff_Name',
            screen: 'Project',
          },
          cellRenderer: 'toolTipRenderer',
          headerTooltip: 'Takeoff',
          resizable: true,
          width: 420,
          filter: 'customFilter',
        },
        {
          headerName: 'Calculation',
          field: 'calculation',
          cellEditor: 'calculationEditor',
          cellStyle: { textAlign: 'left' },
          cellRendererParams: {
            type: 'estimateTakeoff',
            name: 'calculation',
            dropdownData: this.dropdownData.calculation,
          },
          cellRenderer: 'toolTipRenderer',
          headerTooltip: 'Calculation',
          resizable: true,
          sortable: false,
          floatingFilter: false,
          width: 100,
          filter: 'customFilter',
        },
        {
          headerName: 'Quantity',
          field: 'quantity',
          cellEditor: 'inputNumberEditor',
          cellStyle: { textAlign: 'right' },
          headerClass: 'header-right',
          cellRendererParams: {
            type: 'estimateTakeoff',
            placeholder: 'Quantity',
            precision: 0,
            min: 0,
            max: 999999999,
          },
          width: 100,
          cellRenderer: 'toolTipRenderer',
          headerTooltip: 'Quantity',
          resizable: true,
          suppressSizeToFit: true,
          filter: 'customFilter',
        },
        {
          headerName: 'Unit',
          field: 'unit',
          cellEditor: 'selectEditor',
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          cellRendererParams: {
            type: 'estimateTakeoff',
            dropdownName: 'unit',
            dropdownData: this.dropdownData,
          },
          width: 100,
          cellRenderer: 'toolTipRenderer',
          headerTooltip: 'Unit',
          resizable: true,
          suppressSizeToFit: true,
          filter: 'customFilter',
        },
        {
          headerName: 'Construction Quality Factor',
          field: 'constructionQualityFactor',
          headerClass: 'header-center',
          cellEditor: 'selectEditor',
          wrapText: false,
          filter: 'customFilter',
          cellRendererParams: {
            type: 'estimateTakeoff',
            dropdownName: 'constructionQualityFactor',
            dropdownData: this.dropdownData.construction_quality_factor,
            name: 'constructionQualityFactor',
            editable: true,
          },
          width: 150,
          headerTooltip: 'Construction Quality Factor',
          suppressSizeToFit: true,
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Unit Cost',
          field: 'unitCost',
          cellEditor: 'inputNumberEditor',
          cellRenderer: 'costPriceCellRenderer',
          cellStyle: { textAlign: 'right' },
          cellRendererParams: {
            searchType: 'string',
            type: 'estimateTakeoff',
            placeholder: 'Unit Cost',
            precision: 2,
            min: 0,
          },
          width: 120,
          headerTooltip: 'Unit Cost',
          resizable: true,
          suppressSizeToFit: true,
          filter: 'customFilter',
        },
        {
          headerName: 'Multiplier',
          field: 'multiplier',
          cellStyle: { textAlign: 'right' },
          headerClass: 'header-right',
          cellEditor: 'inputNumberEditor',
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: {
            type: 'estimateTakeoff',
            precision: 3,
            name: 'multiplier',
          },
          width: 100,
          resizable: true,
          headerTooltip: 'Multiplier',
          suppressSizeToFit: true,
        },
        {
          headerName: 'Total Cost',
          field: 'totalPrice',
          headerTooltip: 'Total Cost',
          cellRenderer: 'costPriceCellRenderer',
          headerClass: 'header-right',
          cellRendererParams: {
            searchType: 'string',
          },
          width: 100,
          wrapText: false,
          filter: 'customFilter',
          resizable: true,
        },
        {
          headerName: 'Trended Cost',
          field: 'trendedCost',
          headerTooltip: 'Trended Cost',
          cellRenderer: 'costPriceCellRenderer',
          headerClass: 'header-right',
          cellRendererParams: {
            searchType: 'string',
          },
          width: 100,
          wrapText: false,
          filter: 'customFilter',
          resizable: true,
        },
        {
          headerName: 'Action',
          field: 'action',
          sortable: false,
          editable: false,
          cellRenderer: 'actionCellRenderer',
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          cellRendererParams: {
            type: 'estimateTakeoff',
          },
          floatingFilter: false,
          width: 80,
          resizable: false,
          suppressSizeToFit: true,
          headerTooltip: 'Action',
          pinned: 'right',
        },
      ]
    },

    onRowSelected(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
      this.selectedRows = selectedNodes.map(node => node.data)
    },

    onSelectionChanged(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
      this.selectedRows = selectedNodes.map(node => node.data)
    },

    getData(params) {
      const displayColumns = this.refreshColumns()
      params.api.setColumnDefs(displayColumns)
      params.api.sizeColumnsToFit()
      this.takeoffs.forEach(element => {
        if (element.calculation) {
          element.formula = convertCalculation(
            element.calculation,
            this.propData,
            this.groupDetails.calculation,
            this.dropdownData.calculation,
          )
          if (evaluateQantity(element.formula) < 0) {
            element.quantity = element.quantity < 0 ? null : element.quantity
          }
        }
      })
      this.isValidTakeoff = this.takeoffs.some(
        i => typeof i.isValidTakeoff !== 'undefined' && !i.isValidTakeoff,
      )
      if (!this.isValidTakeoff && this.checked) {
        this.sortTakeoffs(this.isValidTakeoff)
      }
      params.api.setRowData(this.takeoffs)
    },

    refreshColumns() {
      const displayColumns = this.columnDefs
      displayColumns.map(col => {
        let align = ''
        if (col.cellStyle) {
          align = col.cellStyle.textAlign
        }
        if (col.field !== 'action') {
          col.cellStyle = param => updateRowStyle(param, col.field, align)
        }
        if (col.headerName !== 'Action' && col.headerName !== '') {
          col.filter = 'customFilter'
          col.menuTabs = this.checked ? [] : ['filterMenuTab']
          col.sortable = !this.checked
        }
        if (this.keys.includes(col.field)) {
          col.editable = true
        } else if (!col.field) {
          col.editable = false
        } else {
          col.editable = false
        }
      })
      return displayColumns
    },

    addTakeoffFrom() {
      this.visibleTakeoff = true
    },

    addTakeoffs() {
      this.loading = true
      const url = projectAPIs.project.asset.estimate.takeoff.add(
        this.$route.params.id,
        this.groupDetails.assetId,
        this.groupDetails.id,
      )
      instance
        .post(url)
        .then(response => {
          let newData = [...this.data]
          newData = newData.concat(_.get(response.data, 'result', []))
          this.data = [...newData]
          var itemsToAdd = addGridRecord(_.get(response.data, 'result', {}))
          this.gridOptions.api.applyTransaction({
            add: itemsToAdd,
          })
          this.gridOptions.api.redrawRows()
          const result = _.get(response.data, 'result', [])
          const indexOfNewRecord = this.data.findIndex(
            val => val.id === result.id,
          )
          this.gridOptions.api.setFocusedCell(indexOfNewRecord, 'takeoff')
          this.gridOptions.api.startEditingCell({
            rowIndex: indexOfNewRecord,
            colKey: 'takeoff',
          })
          this.$emit('onClose', 'add', _.get(response.data, 'result', []))
        })
        .catch(err => {
          this.loading = false
          errorService(err)
        })
    },

    onUpdateTakeoff(value, record, key, index, takeoffData, data, keyCode) {
      this.changeIndex = index
      const findIndex = this.data.findIndex(val => val.id === record.id)

      if (findIndex > -1) {
        const newData = [...this.data]
        const currentValue =
          value === 0 ? value.toString() : !value ? '' : value
        const previousValue = !window.previousValue ? '' : window.previousValue
        if (
          (currentValue !== null &&
            previousValue.toString() !== currentValue.toString()) ||
          key === 'calculation'
        ) {
          const url = projectAPIs.project.asset.estimate.takeoff.update(
            this.$route.params.id,
            this.groupDetails.assetId,
            this.groupDetails.id,
          )
          let enabled = true
          let request
          let isValid = true
          const isPresent = this.selectedRowKeys.some(i => i === record.id)
          const ids = isPresent ? this.selectedRowKeys : [record.id]
          const details = {
            contract: data,
            categoryCode: data,
            record: record,
            list: newData,
            value: value,
            takeoff: takeoffData,
            unit: data,
            constructionQualityFactor: data,
            selectedKeys: ids,
            key: key,
          }
          switch (key) {
            case 'calculation':
              this.loading = true
              request = apiRequestArray(details, index)
              break
            case 'contract':
              this.takeoffDetails = { ...record }
              if (value === 'addContract') {
                this.isAddContract = true
                enabled = false
              } else {
                this.loading = true
                request = apiRequestArray(details, index)
              }
              break
            case 'categoryCode':
              this.takeoffDetails = { ...record }
              if (value === 'addCategory') {
                this.isAddCategory = true
                enabled = false
              } else {
                this.loading = true
                request = apiRequestArray(details, index)
              }
              break
            case 'takeoff':
              this.takeoffDetails = { ...record }
              this.isBlurCalled = false
              window.previousValue = value
              if (value === 'new') {
                this.isAddTakeoff = true
                enabled = false
              } else {
                this.loading = true
                request = apiRequestArray(details, index)
              }
              break
            case 'quantity':
              this.takeoffDetails = { ...record }
              isValid = validateNumber(value, key, 'Quantity')
              if (isValid) {
                request = apiRequestArray(details, index)
              }
              break
            case 'unitCost':
              this.takeoffDetails = { ...record }
              isValid = validateNumber(value, key, 'Unit Cost')
              if (isValid) {
                request = apiRequestArray(details, index)
              }
              break
            case 'multiplier':
              this.takeoffDetails = { ...record }
              isValid = validateNumber(value || 0, key, 'Multiplier')
              if (isValid) {
                request = apiRequestArray(details, index)
              }
              break
            default:
              this.takeoffDetails = { ...record }
              this.loading = true
              request = apiRequestArray(details, index)
              break
          }
          if (enabled && isValid) {
            this.loading = true
            instance
              .patch(url, request)
              .then(response => {
                this.updateTakeoff(
                  response.data,
                  record,
                  newData,
                  key,
                  keyCode,
                  ids,
                )
              })
              .catch(err => {
                this.loading = false
                this.resetRowData(index)
                this.$root.$emit('popupUpdation', false, true, null)
                errorService(err)
              })
          } else if (enabled) {
            this.isBlurCalled = true
            setTimeout(() => {
              this.resetRowData(index)
            }, 100)
          }
        } else {
          this.isBlurCalled = true
          if (
            findIndex === this.data.length - 1 &&
            key === 'multiplier'
          ) {
            this.addTakeoffs()
          }
        }
      }
    },

    updateTakeoff(data, record, newData, key, keyCode, ids) {
      newData = _.get(data.result, 'takeoffs', [])
      ids.forEach(element => {
        const index = this.data.findIndex(val => val.id === element)
        if (record.formula) {
          newData[index].formula = record.formula
        }
        if (key === 'calculation' && evaluateQantity(record.formula) < 0) {
          newData[index].quantity = null
        }
      })
      newData.forEach(element => {
        if (element.calculation) {
          element.formula = convertCalculation(
            element.calculation,
            this.propData,
            this.groupDetails.calculation,
            this.dropdownData.calculation,
          )
          if (evaluateQantity(element.formula) < 0) {
            element.quantity = element.quantity < 0 ? null : element.quantity
          }
        }
      })
      this.gridOptions.api.redrawRows()
      const itemsToUpdate = updateMultipleGridRecord(this.gridOptions, newData)
      this.gridOptions.api.applyTransaction({
        update: itemsToUpdate,
      })
      this.data = [...newData]
      this.gridOptions.api.redrawRows()
      if (record) {
        const rowIndex = this.data.findIndex(val => val.id === record.id)
        this.gridOptions.api.forEachNodeAfterFilter(node => {
          node.setSelected(false)
        })
        this.$root.$emit('popupUpdation', false, true, null)
        this.setActiveCell(key, rowIndex, keyCode)
        this.$emit('onClose', 'update', newData, data)
      }
      this.isValidTakeoff = this.data.some(
        i => typeof i.isValidTakeoff !== 'undefined' && !i.isValidTakeoff,
      )
      if (!this.isValidTakeoff && this.checked) {
        this.sortTakeoffs(this.isValidTakeoff)
      }
      this.loading = false
      this.isBlurCalled = true
      this.takeoffDetails = null
    },

    setActiveCell(key, index, keyCode) {
      const focusedCell = this.gridOptions.api.getFocusedCell()
      let focusKey
      if (focusedCell) {
        switch (key) {
          case 'contract':
            focusKey = 'categoryCode'
            break
          case 'categoryCode':
            focusKey = 'additionalDescription'
            window.previousValue = ''
            break
          case 'additionalDescription':
            focusKey = 'takeoff'
            window.previousValue = ''
            break
          case 'takeoff':
            focusKey = 'calculation'
            break
          case 'calculation':
            focusKey = 'quantity'
            window.previousValue = ''
            break
          case 'quantity':
            focusKey = 'unit'
            window.previousValue = ''
            break
          case 'unit':
            focusKey = 'constructionQualityFactor'
            window.previousValue = ''
            break
          case 'constructionQualityFactor':
            window.previousValue = ''
            focusKey = 'unitCost'
            break
          case 'unitCost':
            focusKey = 'multiplier'
            window.previousValue = ''
            break
          case 'multiplier':
            window.previousValue = ''
            if (index === this.data.length - 1) {
              this.addTakeoffs()
            }
            break
          default:
            break
        }
        if (key !== 'multiplier') {
          this.gridOptions.api.setFocusedCell(index, focusKey)
          this.gridOptions.api.startEditingCell({
            rowIndex: index,
            colKey: focusKey,
          })
        }
      }
    },

    resetRowData(index) {
      const newData = [...this.data]
      if (newData[index]) {
        if (this.takeoffDetails.formula) {
          newData[index].formula = this.takeoffDetails.formula
        }
      }
      newData[index].quantity = this.takeoffDetails.quantity
      newData[index] = this.takeoffDetails
      this.data = [...newData]
      this.gridOptions.api.redrawRows()
      const itemsToUpdate = updateGridRecord(
        this.gridOptions,
        this.takeoffDetails,
        newData[index],
      )
      this.gridOptions.api.applyTransaction({
        update: itemsToUpdate,
      })
      this.gridOptions.api.redrawRows()
      const focusedCell = this.gridOptions.api.getFocusedCell()
      if (focusedCell) {
        this.gridOptions.api.setFocusedCell(
          focusedCell.rowIndex,
          focusedCell.column.colId,
        )
        this.gridOptions.api.startEditingCell({
          rowIndex: focusedCell.rowIndex,
          colKey: focusedCell.column.colId,
        })
      }
      this.takeoffDetails = null
    },

    deleteAllRecord() {
      if (this.selectedRowKeys.length > 0) {
        var that = this
        this.$confirm({
          title: `Are you sure want to delete ${this.selectedRowKeys.length} records?`,
          content: h => (
            <div style="color:red">
              <p>This action will delete all information related these rows.</p>
              <p>Please confirm.</p>
            </div>
          ),
          onOk() {
            that.confirmDelete(null)
          },
        })
      } else {
        showNotification(
          'warning',
          'Takeoffs',
          'Please select at least one takeoff!',
        )
      }
    },

    deleteRecord(record) {
      var that = this
      this.$confirm({
        title: `Are you sure want to delete takeoff ?`,
        content: h => (
          <div style="color:red">
            <p>
              This action will delete all information related this line item.
            </p>
            <p>Please confirm.</p>
          </div>
        ),
        onOk() {
          that.confirmDelete(record)
        },
      })
    },

    confirmDelete(record) {
      this.loading = true
      const url = projectAPIs.project.asset.estimate.takeoff.delete(
        this.$route.params.id,
        this.groupDetails.assetId,
        this.groupDetails.id,
      )
      const ids = record ? [record.id] : this.selectedRowKeys
      instance
        .delete(url, { data: ids })
        .then(response => {
          ids.map(element => {
            const findIndex = this.data.findIndex(val => val.id === element)
            if (findIndex > -1) {
              this.data.splice(findIndex, 1)
            }
          })
          if (record) {
            this.gridOptions.api.applyTransaction({ remove: [record] })
          } else {
            this.gridOptions.api.applyTransaction({
              remove: this.selectedRows,
            })
          }
          this.loading = false
          this.updateTakeoff(response.data, null, this.data, null, null, [])
          this.$emit(
            'onClose',
            'delete',
            record ? [record] : this.selectedRows,
            response.data,
          )
          this.selectedRowKeys = []
          this.selectedRows = []
        })
        .catch(err => {
          this.loading = false
          errorService(err)
        })
    },

    cloneTakeoff(id) {
      this.clone(id)
    },

    cloneTakeoffs() {
      if (this.selectedRowKeys.length > 0) {
        this.clone()
      } else {
        showNotification(
          'warning',
          'Takeoffs',
          'Please select at least one takeoff!',
        )
      }
    },

    clone(id) {
      this.loading = true
      const url = projectAPIs.project.asset.estimate.takeoff.clone(
        this.$route.params.id,
        this.groupDetails.assetId,
        this.groupDetails.id,
      )
      const newData = [...this.data]
      const isPresent = id ? this.selectedRowKeys.some(i => i === id) : true
      const ids = isPresent ? this.selectedRowKeys : [id]
      instance
        .put(url, ids)
        .then(response => {
          this.gridOptions.api.forEachNodeAfterFilter(node => {
            node.setSelected(false)
          })
          const itemsToAdd = addMultipleGridRecord(
            newData,
            _.get(response.data, 'result.takeoffs', []),
          )
          this.gridOptions.api.applyTransaction({
            add: itemsToAdd,
          })
          this.updateTakeoff(response.data, null, newData, null, null, [])
          this.$emit('onClose', 'clone', itemsToAdd, response.data)
        })
        .catch(err => {
          this.loading = false
          errorService(err)
        })
    },

    gridSizeChanged(e) {
      const element = document.querySelector('#estimateGroupTable')
      if (element) {
        this.gridOptions.api.sizeColumnsToFit()
      }
    },

    tabToNextCell(params) {
      const previousCell = params.previousCellPosition
      const nextCellPosition = params.nextCellPosition
      let result = null
      const isTab = true
      if (isTab && nextCellPosition) {
        result = {
          rowIndex: nextCellPosition.rowIndex,
          column: nextCellPosition.column,
          floating: previousCell.floating,
        }
        return result
      }
    },

    onCellValueChanged(event) {
      if (event.colDef.field === 'calculation') {
        if (event.value) {
          this.takeoffDetails = { ...event.data }
          this.takeoffDetails.calculation = event.oldValue
          if (event.oldValue) {
            this.takeoffDetails.formula = convertCalculation(
              event.oldValue,
              null,
              this.groupDetails.calculation,
              this.dropdownData.calculation,
            )
          }
          const calculation = convertCalculation(
            event.value,
            null,
            this.groupDetails.calculation,
            this.dropdownData.calculation,
          )
          event.data.formula = calculation
          const reg = /^[0-9. ()]+([-+*/()]+[ -+()]?[ 0-9.()]+)*$/
          if (!reg.test(calculation)) {
            showNotification(
              'error',
              'Calculation',
              'Invalid formula. Please validate the formula and try again.',
            )
            this.isCalculationError = true
            this.resetRowData(event.rowIndex)
          } else if (evaluateQantity(event.data.formula) === 'Error') {
            showNotification(
              'error',
              'Calculation',
              'Invalid formula. Please validate the formula and try again.',
            )
            this.isCalculationError = true
            this.resetRowData(event.rowIndex)
          } else {
            this.onUpdateTakeoff(
              event.value,
              event.data,
              event.colDef.field,
              event.rowIndex,
              event.colDef.cellRendererParams.dataType,
              null,
              null,
              event.keyCode,
            )
          }
        } else {
          event.data.formula = undefined
          this.onUpdateTakeoff(
            event.value,
            event.data,
            event.colDef.field,
            event.rowIndex,
            event.colDef.cellRendererParams.dataType,
            null,
            null,
            event.keyCode,
          )
        }
      } else if (event.colDef.field === 'takeoff' && this.isBlurCalled) {
        if (event.value.length > 200) {
          showNotification(
            'error',
            'Takeoff',
            'Takeoff should consist of 200 characters only!',
          )
        } else {
          this.onUpdateTakeoff(
            event.value,
            event.data,
            event.colDef.field,
            event.rowIndex,
            null,
            null,
            null,
          )
        }
      }
      this.isBlurCalled = true
    },

    addContract(data, flag) {
      this.isAddContract = flag
      const newData = [...this.data]
      const index = newData.findIndex(i => i.id === this.takeoffDetails.id)
      if (data) {
        this.gridOptions.api.redrawRows()
        this.onUpdateTakeoff(
          data.contract,
          this.takeoffDetails,
          'contract',
          index,
          null,
          data,
          null,
        )
        this.$root.$emit('addContract', data)
      } else {
        this.resetRowData(index)
      }
    },

    addCategory(data, contracts, flag) {
      this.isAddCategory = flag
      const newData = [...this.data]
      const index = newData.findIndex(i => i.id === this.takeoffDetails.id)
      if (data) {
        const category = {
          id: data.id,
          masterId: data.masterId,
          option: `${data.categoryCode} - ${data.description}`,
          value: `${data.categoryCode} - ${data.description}`,
          description: data.description,
          contractDetailsId: data.mContractDetailsId,
        }
        this.gridOptions.api.redrawRows()
        this.onUpdateTakeoff(
          data.categoryCode,
          this.takeoffDetails,
          'categoryCode',
          index,
          null,
          category,
          null,
        )
        this.$root.$emit('addCategoryCode', category, contracts)
      } else {
        this.resetRowData(index)
      }
    },

    addTakeOff(action) {
      this.isAddTakeoff = false
      const newData = [...this.data]
      const index = newData.findIndex(i => i.id === this.takeoffDetails.id)
      if (action === 'cancel') {
        if (this.takeoffDetails.formula) {
          newData[index].formula = this.takeoffDetails.formula
        }
        newData[index].area = this.propData.firstRowValues.area
        this.data = [...newData]
        this.gridOptions.api.redrawRows()
        const itemsToUpdate = updateGridRecord(
          this.gridOptions,
          this.takeoffDetails,
          newData[index],
        )
        this.gridOptions.api.applyTransaction({ update: itemsToUpdate })
        this.gridOptions.api.redrawRows()
        this.setActiveCell('additionalDescription', index, null)
      } else {
        this.gridOptions.api.redrawRows()
        this.setActiveCell('additionalDescription', index, null)
      }
      this.takeoffDetails = null
    },

    closeTakeoff(flag) {
      this.visibleTakeoff = flag
    },

    reloadTakeoffs(data) {
      this.loading = false
      const newData = [...this.data]
      const itemsToAdd = addMultipleGridRecord(
        newData,
        _.get(data.result, 'takeoffs', []),
      )
      this.gridOptions.api.applyTransaction({
        add: itemsToAdd,
      })
      this.updateTakeoff(data, null, newData, null, null, [])
      this.$root.$emit('stopLoader', false)
    },

    addNewTakeoffs(flag) {
      this.$emit('addNewTakeoffs', flag)
    },

    sortTakeoffs(value) {
      let sort = 'asc'
      let key = 'sequence'
      this.checked = value
      this.gridOptions.columnApi.applyColumnState({
        defaultState: { sort: null },
      })
      this.gridOptions.api.setFilterModel(null)
      if (value) {
        sort = 'asc'
        key = 'isValidTakeoff'
      }
      this.gridOptions.columnApi.applyColumnState({
        state: [
          {
            colId: key,
            sort: sort,
          },
        ],
        defaultState: { sort: null },
      })
      const displayColumns = this.refreshColumns()
      this.gridOptions.api.setColumnDefs(displayColumns)
      this.gridOptions.api.sizeColumnsToFit()
    },

    filterChanged() {
      this.isValidTakeoff = this.data.some(
        i => typeof i.isValidTakeoff !== 'undefined' && !i.isValidTakeoff,
      )
    },

    stopLoading(flag) {
      this.loading = flag
    },
  },
}
